import type { PlantillaFuente } from './types';

/** Grupo para cierres, horarios y puentes: plantillas de festivo sin fecha propia. */
export const GRUPO_CIERRES = 'cierres';
export const NOMBRE_CIERRES = 'Cierres y puentes';

/** Fecha aproximada (mes, día) de cada ocasión, para mostrar primero las que se vienen. */
const FECHAS: Record<string, [number, number]> = {
  reyes: [1, 6],
  'rebajas-enero': [1, 10],
  'regreso-clases': [1, 20],
  'san-valentin': [2, 14],
  carnaval: [2, 20],
  'dia-mujer': [3, 8],
  'dia-hombre': [3, 19],
  'semana-santa': [4, 1],
  'dia-libro': [4, 23],
  'dia-nino': [4, 25],
  'dia-trabajo': [5, 1],
  'dia-madre': [5, 10],
  'dia-maestro': [5, 15],
  'dia-padre': [6, 20],
  prima: [6, 25],
  vacaciones: [6, 28],
  independencia: [7, 20],
  'feria-flores': [8, 5],
  'dia-mascota': [8, 26],
  'amor-amistad': [9, 19],
  'dia-cafe': [10, 1],
  halloween: [10, 31],
  'black-friday': [11, 27],
  'cyber-monday': [11, 30],
  velitas: [12, 7],
  novenas: [12, 16],
  navidad: [12, 25],
  'ano-nuevo': [12, 31],
};

export function grupoOcasion(p: PlantillaFuente): string {
  const o = p.manifest.ocasion;
  return !o || o === 'puente-festivo' ? GRUPO_CIERRES : o;
}

function diasHasta(ocasion: string, hoy: Date): number {
  const f = FECHAS[ocasion];
  if (!f) return 400;
  const inicio = Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  let fecha = Date.UTC(hoy.getFullYear(), f[0] - 1, f[1]);
  if (fecha < inicio) fecha = Date.UTC(hoy.getFullYear() + 1, f[0] - 1, f[1]);
  return Math.round((fecha - inicio) / 86400000);
}

/** Ocasiones presentes en las plantillas: cierres primero, luego las fechas que se vienen. */
export function ocasionesOrdenadas(plantillas: PlantillaFuente[], hoy: Date = new Date()): { id: string; nombre: string }[] {
  const nombres = new Map<string, string>();
  for (const p of plantillas) {
    if (p.manifest.categoria !== 'festivo') continue;
    const id = grupoOcasion(p);
    if (!nombres.has(id)) nombres.set(id, id === GRUPO_CIERRES ? NOMBRE_CIERRES : p.manifest.ocasion_nombre || id);
  }
  return Array.from(nombres.entries())
    .map(([id, nombre]) => ({ id, nombre }))
    .sort((a, b) => {
      if (a.id === GRUPO_CIERRES) return -1;
      if (b.id === GRUPO_CIERRES) return 1;
      return diasHasta(a.id, hoy) - diasHasta(b.id, hoy);
    });
}
